module.exports = __webpack_public_path__ + "img/beian.a401240e.jpg";